export var borderColor = 'var(--_foryfi1-2-0-1)';
export var rangeColor = 'var(--_foryfi0-2-0-1)';